<template>
  <side-panel-inner
    :headerTitle="editMode ? 'Edit Tag' : 'Create a Tag'"
    on-close="AdminDocumentsCategories"
    class="p-category-create"
  >
    <template v-if="editMode" slot="actions">
      <base-button
        :danger="true"
        button-style="danger"
        @click="deleteCategory"
        iconBefore="delete"
      >Delete</base-button>
      <base-button success :primary="true" @click="onFormSubmit">Save</base-button>
    </template>

    <template v-else slot="actions">
      <base-button :primary="true" @click="onFormSubmit">Create</base-button>
    </template>

    <!-- Category Name -->
    <message type="error" v-if="showValidationMessage">
      <h3>Form Invalid</h3>
      <p>Form is invalid, please check and try again.</p>
    </message>

    <tag-form ref="form" v-if="!loading && formReady" @submit="onFormSubmit"></tag-form>

    <loading v-if="loading"></loading>
  </side-panel-inner>
</template>

<script>
import TagForm from '@/views/admin/categories/TagForm';

export default {
  name: 'category-edit-create',

  data() {
    return {
      showValidationMessage: false,
      editMode: false,
      loading: false,
      formReady: false,
      category: {
        name: null,
        description: null,
      },
    };
  },

  beforeMount() {
    const tagId = this.$route.params.id;

    if (tagId) {
      this.editMode = true;
      this.$store.dispatch('tags/readDocumentTag', tagId).then(() => {
        this.formReady = true;
      });
    } else {
      this.editMode = false;
      const tag = {
        name: null,
        description: null,
      };
      this.$store.commit('tags/setCurrentTag', {
        tag,
      });
      this.formReady = true;
    }
  },

  methods: {
    onFormSubmit() {
      const vm = this;

      vm.$refs.form.$validator.validate().then((result) => {
        if (!result) {
          vm.showValidationMessage = true;
        } else {
          vm.showValidationMessage = false;
          vm.editMode ? vm.updateTag() : vm.createTag();
        }
      });
    },

    createTag() {
      const vm = this;
      this.$store.dispatch('tags/createDocumentTag').then(() => {
        vm.$store.dispatch('CLOSE_PANEL');
      });
    },

    updateTag() {
      const vm = this;
      vm.$store
        .dispatch('tags/updateDocumentTag', vm.$route.params.id)
        .then(() => {
          vm.$store.dispatch('CLOSE_PANEL');
        });
    },

    deleteTag() {
      const vm = this;
      this.$store.dispatch('createDialog', {
        confirm: () => {
          vm.$store
            .dispatch('tags/deleteDocumentTag', vm.$route.params.id)
            .then(() => {
              vm.$store.dispatch('CLOSE_PANEL');
            });
        },
      });
    },
  },

  computed: {
    formIsValid() {
      return this.category.name;
    },
  },

  components: {
    TagForm,
  },
};
</script>
